import { apiClient } from '@/shared/data/client';
import type { RegisterInterestDto } from '@flowqa/shared';

type RegisterInterestCreateInput = {
  firstName: string;
  lastName: string;
  email: string;
  companyName?: string | null;
  role?: string | null;
  companySize?: string | null;
};

export const createRegisterInterest = async (
  input: RegisterInterestCreateInput,
): Promise<RegisterInterestDto> => {
  return await apiClient.post<RegisterInterestDto>('public/register-interest', input);
};
